var _AjaxSpiner, _ConfirmationIcon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Button from '../Button/index.js';
import AjaxSpiner from '../AjaxSpinner/index.js';
import ConfirmationIcon from './ConfirmationIcon.js';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AnimatedButton(_ref) {
  let {
    buttonState = '',
    buttonText,
    loadedText,
    onClick,
    buttonWidth,
    className,
    ...rest
  } = _ref;
  let Content;
  switch (buttonState) {
    case 'loading':
      Content = _AjaxSpiner || (_AjaxSpiner = /*#__PURE__*/_jsx(AjaxSpiner, {}));
      break;
    case 'loaded':
      Content = /*#__PURE__*/_jsxs(_Fragment, {
        children: [_ConfirmationIcon || (_ConfirmationIcon = /*#__PURE__*/_jsx(ConfirmationIcon, {})), /*#__PURE__*/_jsx("span", {
          className: "animated-text padding-left-2",
          children: loadedText
        })]
      });
      break;
    default:
      Content = buttonText;
  }
  const buttonClassName = clsx('display-inline-block btn-animated display-flex justify-content-center align-items-center', buttonState, className);
  return /*#__PURE__*/_jsx(Button, {
    className: buttonClassName,
    onClick: onClick,
    style: {
      minWidth: buttonWidth
    },
    ...rest,
    children: Content
  });
}
export default AnimatedButton;